// Smiley-Motive: 22 mehrfarbige SVG-Icons (von Anke ueber die Inbox geliefert,
// abgelegt in `icons/`). Wie die Personen-Avatare ist jedes Motiv ein
// vollstaendiges, mehrfarbiges SVG; der Renderer zeichnet es als Bild
// (`Konva.Image`), nicht als einzelnen Pfad. Ein `id="fill"`-Element in fast
// jedem Icon wird mit der Fuellfarbe eingefaerbt (icon2 hat keins).

import icon1 from './icons/icon1.svg?raw';
import icon2 from './icons/icon2.svg?raw';
import icon3 from './icons/icon3.svg?raw';
import icon4 from './icons/icon4.svg?raw';
import icon5 from './icons/icon5.svg?raw';
import icon6 from './icons/icon6.svg?raw';
import icon7 from './icons/icon7.svg?raw';
import icon8 from './icons/icon8.svg?raw';
import icon9 from './icons/icon9.svg?raw';
import icon10 from './icons/icon10.svg?raw';
import icon11 from './icons/icon11.svg?raw';
import icon12 from './icons/icon12.svg?raw';
import icon13 from './icons/icon13.svg?raw';
import icon14 from './icons/icon14.svg?raw';
import icon15 from './icons/icon15.svg?raw';
import icon16 from './icons/icon16.svg?raw';
import icon17 from './icons/icon17.svg?raw';
import icon18 from './icons/icon18.svg?raw';
import icon19 from './icons/icon19.svg?raw';
import icon20 from './icons/icon20.svg?raw';
import icon21 from './icons/icon21.svg?raw';
import icon22 from './icons/icon22.svg?raw';

export type SmileyIcon =
  | 'icon1' | 'icon2' | 'icon3' | 'icon4' | 'icon5' | 'icon6' 
  | 'icon7' | 'icon8' | 'icon9' | 'icon10' | 'icon11' | 'icon12' 
  | 'icon13' | 'icon14' | 'icon15' | 'icon16' | 'icon17' | 'icon18' 
  | 'icon19' | 'icon20' | 'icon21' | 'icon22' ;

export interface SmileyIconDef {
  /** Vollstaendiges, mehrfarbiges SVG-Markup (als Bild gerendert). */
  readonly svg: string;
  /** viewBox-Breite / -Hoehe fuer die Seitenverhaeltnis-Normalisierung. */
  readonly vbWidth: number;
  readonly vbHeight: number;
}

/** Liest Breite/Hoehe aus der viewBox des SVG (Single Source of Truth). */
function readViewBox(svg: string): { vbWidth: number; vbHeight: number } {
  const m = svg.match(/viewBox="0 0 ([0-9.]+) ([0-9.]+)"/);
  return {
    vbWidth: m ? parseFloat(m[1]!) : 0,
    vbHeight: m ? parseFloat(m[2]!) : 0,
  };
}

function def(svg: string): SmileyIconDef {
  return { svg, ...readViewBox(svg) };
}

export const SMILEY_ICONS: Record<SmileyIcon, SmileyIconDef> = {
  'icon1': def(icon1),
  'icon2': def(icon2),
  'icon3': def(icon3),
  'icon4': def(icon4),
  'icon5': def(icon5),
  'icon6': def(icon6),
  'icon7': def(icon7),
  'icon8': def(icon8),
  'icon9': def(icon9),
  'icon10': def(icon10),
  'icon11': def(icon11),
  'icon12': def(icon12),
  'icon13': def(icon13),
  'icon14': def(icon14),
  'icon15': def(icon15),
  'icon16': def(icon16),
  'icon17': def(icon17),
  'icon18': def(icon18),
  'icon19': def(icon19),
  'icon20': def(icon20),
  'icon21': def(icon21),
  'icon22': def(icon22),
};

/** Default-Motiv fuer einen frisch platzierten Smiley. */
export const DEFAULT_SMILEY_ICON: SmileyIcon = 'icon8';

/** Reihenfolge der icon1..icon22-Knoepfe im Optionskreis (part8).
 *  Index i (0-basiert) entspricht der SVG-`id` `icon${i+1}`. */
export const SMILEY_ICON_ORDER: readonly SmileyIcon[] = [
  'icon1', 'icon2', 'icon3', 'icon4', 'icon5', 'icon6', 
  'icon7', 'icon8', 'icon9', 'icon10', 'icon11', 'icon12', 
  'icon13', 'icon14', 'icon15', 'icon16', 'icon17', 'icon18', 
  'icon19', 'icon20', 'icon21', 'icon22', 
];
